<div class="action-bar-container" data-link-ga-node="ActionBar">
  <div class="primary-action-items d-flex">
    <ng-container *ngFor="let item of model.primaryItems$()">
      <a [ngClass]="item.classNames ? item.classNames : ['action-item']"
         *linkAccessControl="item.accessControlName || ''"
         [attr.data-link-ga-node]="item.name"
         (click)="actionClicked(item.name)">
        @if (item.label) {
          {{item.label | translate}}
        }
      </a>
    </ng-container>
  </div>
  <div class="secondary-action-items d-flex">
    <ng-container *ngFor="let item of model.secondaryItems$()">
      <a [ngClass]="item.classNames ? item.classNames : ['action-item']"
         *linkAccessControl="item.accessControlName || ''"
         [attr.data-link-ga-node]="item.name"
         (click)="actionClicked(item.name)">
        @if (item.label) {
          {{item.label | translate}}
        }
      </a>
    </ng-container>
  </div>
</div>
